export default {
  computed: {
    // 是否处于活动桥接页，桥接页需要用 query.url 里的真实页面地址做导航匹配。
    isActivityBridgeBottomNavigation() {
      return this.$route && this.$route.name === 'giftCenter.activityBridge';
    },
    // 获取导航入口类型，优先取 vue-router query，兜底兼容原始地址栏参数。
    bottomNavigationJumpType() {
      const routeJumpType = this.$route && this.$route.query && this.$route.query.jumpType;
      if (routeJumpType) {
        return routeJumpType;
      }
      return new URLSearchParams(window.location.search || '').get('jumpType') || '';
    },
    // 计算当前导航类型：0 不展示、1 普通底部导航、3 活动底部导航。
    bottomNavigationType() {
      if (!this.isActivityBridgeBottomNavigation && this.bottomNavigationJumpType === 'activity') {
        return 0;
      }
      if (!this.isActivityBridgeBottomNavigation) {
        return 1;
      }
      const jumpType = this.bottomNavigationJumpType;
      if (jumpType === 'activity') {
        return 3;
      }
      if (jumpType === 'bottom') {
        return 1;
      }
      return 0;
    },
    // 当前用于高亮/匹配的地址，活动桥接页使用被桥接的真实地址。
    bottomNavigationMatchUrl() {
      if (
        this.isActivityBridgeBottomNavigation &&
        this.$route.query &&
        this.$route.query.url
      ) {
        return this.$route.query.url;
      }
      return this.getCurrentRoutePath();
    },
    // 活动导航不按 level 拆分，直接使用接口返回的完整导航列表。
    activityBottomNavArray() {
      const navList = Array.isArray(this.bottomNavArray) ? this.bottomNavArray : [];
      return navList.slice();
    },
    // 一级底部导航列表。
    firstLevelBottomNavArray() {
      return this.getBottomNavByLevel(1);
    },
    // 二级底部导航列表。
    secondLevelBottomNavArray() {
      return this.getBottomNavByLevel(2);
    },
    // 当前命中的导航层级：0 未命中、1 一级、2 二级、3 活动导航。
    currentBottomNavLevel() {
      if (!Number(this.bottomNavigationType)) {
        return 0;
      }
      if (Number(this.bottomNavigationType) === 3) {
        return this.hasMatchedNavigation(this.activityBottomNavArray) ? 3 : 0;
      }
      if (this.hasMatchedNavigation(this.firstLevelBottomNavArray)) {
        return 1;
      }
      if (this.hasMatchedNavigation(this.secondLevelBottomNavArray)) {
        return 2;
      }
      return 0;
    },
    // 当前页面最终需要渲染的导航列表。
    currentLevelBottomNavArray() {
      if (this.currentBottomNavLevel === 1) {
        return this.firstLevelBottomNavArray;
      }
      if (this.currentBottomNavLevel === 2) {
        return this.secondLevelBottomNavArray;
      }
      if (this.currentBottomNavLevel === 3) {
        return this.activityBottomNavArray;
      }
      return [];
    },
    // 是否存在和当前页面匹配的底部导航。
    hasMatchedBottomNav() {
      return this.currentBottomNavLevel > 0;
    },
  },
  methods: {
    // 按导航层级过滤，倒序兼容后端配置顺序。
    getBottomNavByLevel(level) {
      const navList = Array.isArray(this.bottomNavArray) ? this.bottomNavArray : [];
      return navList
        .slice()
        .reverse()
        .filter(item => Number(item.level) === level);
    },
    // 归一化 query 顺序，避免同一组 query 因参数顺序不同导致无法匹配。
    getNormalizedNavigationSearch(search = '') {
      const searchStr = String(search || '').replace(/^\?/, '');
      if (!searchStr) {
        return '';
      }
      const queryList = [];
      const searchParams = new URLSearchParams(searchStr);

      searchParams.forEach((value, key) => {
        queryList.push([key, value]);
      });
      queryList.sort((a, b) => {
        if (a[0] !== b[0]) {
          return a[0] > b[0] ? 1 : -1;
        }
        if (a[1] !== b[1]) {
          return a[1] > b[1] ? 1 : -1;
        }
        return 0;
      });

      const normalizedParams = new URLSearchParams();
      queryList.forEach(([key, value]) => {
        normalizedParams.append(key, value);
      });
      const normalizedSearch = normalizedParams.toString();
      return normalizedSearch ? `?${normalizedSearch}` : '';
    },
    // 将导航地址归一化为 path + search，保留 query 避免不同入口误判为同一导航。
    getNavigationRoutePath(url) {
      if (!url) {
        return '';
      }
      const urlStr = String(url).trim();
      const hashIndex = urlStr.indexOf('#');
      const hashRoute = hashIndex > -1 ? urlStr.slice(hashIndex + 1) : '';
      let routeStr = hashRoute.indexOf('/') === 0 ? hashRoute : urlStr;

      if (/^https?:\/\//i.test(routeStr)) {
        try {
          const parsedUrl = new URL(routeStr);
          routeStr = `${parsedUrl.pathname}${parsedUrl.search}`;
        } catch (error) {}
      }

      const routeWithoutHash = routeStr.replace(/^#/, '').split('#')[0];
      const queryIndex = routeWithoutHash.indexOf('?');
      const path = (queryIndex > -1 ? routeWithoutHash.slice(0, queryIndex) : routeWithoutHash);
      const search = queryIndex > -1 ? routeWithoutHash.slice(queryIndex) : '';

      if (!path) {
        return '';
      }
      const normalizedPath = path.indexOf('/') === 0 ? path : `/${path}`;
      return `${normalizedPath}${this.getNormalizedNavigationSearch(search)}`;
    },
    // 获取当前页面的匹配地址，优先使用 vue-router fullPath 以保留 query。
    getCurrentRoutePath() {
      if (this.$route && this.$route.fullPath) {
        return this.$route.fullPath;
      }
      return this.getNavigationRoutePath(window.location.hash);
    },
    // 判断导航地址和当前匹配地址是否为同一个 path + search。
    isSameNavigationRoute(url, currentPath = this.bottomNavigationMatchUrl) {
      return this.getNavigationRoutePath(url) === this.getNavigationRoutePath(currentPath);
    },
    // 判断导航列表中是否存在当前页面命中的导航项。
    hasMatchedNavigation(navList) {
      if (!Array.isArray(navList)) {
        return false;
      }
      return navList.some(item => this.isSameNavigationRoute(item.url));
    },
  },
};
